

import React, { useState, useEffect } from 'react';
import { Check } from 'lucide-react';
import { FaPhone, FaUtensils, FaCheckSquare } from 'react-icons/fa';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { VerifyToken } from '../../../MiddleWare/verifyToken';

const SuccessPage = () => {
  const [animationState, setAnimationState] = useState('initial');
  const [orderid, setOrderId] = useState('');
  const navigate = useNavigate();
  VerifyToken();

  const getCurrentUserId = async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('Unauthorized');
    }
    const response = await fetch(`${process.env.REACT_APP_URL}/api/user/getuser/${token}`);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data.customer_generated_id;
  };

  useEffect(() => {
    const fetchOrderAndGroupDetails = async () => {
      try {
        // Fetch order ID
        const response = await axios.get(`${process.env.REACT_APP_URL}/api/groups/getGOrdergenId`, {
          headers: { token: localStorage.getItem('token') },
        });
        setOrderId(response.data.order_genid.order_generated_id);

        // Fetch user's group code
        const userId = await getCurrentUserId();
        const groupsResponse = await axios.get(`${process.env.REACT_APP_URL}/api/fetchgroups`);
        const userGroup = groupsResponse.data?.find(group => 
          group.groupmembers.some(member => 
            member.customer_generated_id === userId
          )
        );

        if (userGroup) {
          localStorage.setItem('groupCode', userGroup.groupcode);
        }
      } catch (error) {
        console.error('Error in fetching details:', error);
      }
    };

    fetchOrderAndGroupDetails();

    const timer = setTimeout(() => {
      setAnimationState('animated');
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const navigateTimer = setTimeout(() => {
      navigate('/mygrouporders');
    }, 6000);

    return () => clearTimeout(navigateTimer);
  }, [navigate]);

  useEffect(() => {
    const currentUser = clearLocalStorageExceptToken();
    clearCartData(currentUser);
  }, []);

  const clearLocalStorageExceptToken = () => {
    const token = localStorage.getItem('token');
    const groupCode = localStorage.getItem('groupCode'); // Preserve group code
    const currentUser = JSON.parse(localStorage.getItem('userDP'))?.email;
    localStorage.clear();
    localStorage.setItem('token', token);
    if (groupCode) localStorage.setItem('groupCode', groupCode); // Restore group code
    return currentUser;
  };

  const clearCartData = (currentUser) => {
    if (currentUser) {
      localStorage.removeItem(`cartItems_${currentUser}`);
      localStorage.setItem(`paymentComplete_${currentUser}`, 'true');
    }
  };

  return (
    <div className="h-screen w-full bg-white flex flex-col items-center justify-center overflow-hidden">
      <div
        className={`w-full h-full flex flex-col items-center justify-center transition-all duration-1000 ease-in-out
          ${animationState === 'animated' ? 'rounded-full w-45 h-70 -translate-y-24 bg-orange-800' : 'bg-orange-600'}`}
      >
        <div className="flex items-center justify-center bg-orange-100 bg-opacity-50 rounded-full w-24 h-24">
          <div className="flex items-center justify-center bg-white w-13 h-13 rounded-md">
            <Check className="text-orange-500 w-8 h-8" />
          </div>
        </div>

        <p className="text-white text-lg mt-2">Order Successful</p>
        <p className="text-white text-sm">11 September 2024 at 12:22pm</p>
        <p className="text-white text-sm">Order Id: {orderid}</p>
      </div>

      {animationState === 'animated' && (
        <div className="mb-14 w-80 bg-white rounded-lg shadow-md p-4 animate-fade-in border border-orange-800">
          <h2 className="text-lg font-semibold mb-2">Booking Status</h2>
          <ul className="space-y-2">
            <div className="bg-white shadow-md p-3 flex items-center justify-between">
              <div className="flex items-center">
                <FaPhone className="block text-black w-5 h-5 mr-3" />
                <div className="flex flex-col">
                  <span className="block">Payment Received</span>
                  <span className="text-xs text-gray-500">We have received your payment</span>
                </div>
              </div>
              <span className="w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center text-white">1</span>
            </div>

            <div className="bg-white shadow-md p-3 flex items-center justify-between">
              <div className="flex items-center">
                <FaUtensils className="block text-black w-5 h-5 mr-3" />
                <div className="flex flex-col">
                  <span className="block">Confirm from MeraCrackers</span>
                </div>
              </div>
              <span className="w-6 h-6 bg-orange-300 rounded-full flex items-center justify-center text-white">2</span>
            </div>

            <div className="bg-white shadow-md p-3 flex items-center justify-between">
              <div className="flex items-center">
                <FaCheckSquare className="block text-black w-5 h-5 mr-3" />
                <div className="flex flex-col">
                  <span className="block">Booking Confirmed</span>
                  <span className="text-xs text-gray-500">Your Booking is confirmed now</span>
                </div>
              </div>
              <span className="w-6 h-6 bg-orange-700 rounded-full flex items-center justify-center text-white">3</span>
            </div>
          </ul>
        </div>
      )}
    </div>
  );
};

export default SuccessPage;
